import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FaqList = ({ faqs, prefix = "faq" }) => (
  <Accordion type="single" collapsible className="divide-y divide-slate-200 rounded-3xl bg-white px-5 ring-1 ring-slate-200 sm:px-8">
    {faqs.map((f, i) => (
      <AccordionItem key={f.id} value={f.id} className="border-0">
        <AccordionTrigger className="py-5 text-left text-base font-semibold text-brand-ink hover:no-underline md:text-lg" data-testid={`${prefix}-question-${i}`}>
          {f.question}
        </AccordionTrigger>
        <AccordionContent forceMount className="pb-5 text-base leading-relaxed text-slate-700">{f.answer}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
